// extracted by mini-css-extract-plugin
export default {"AbautsSkills":"AbautsSkills_AbautsSkills__HE0yT","AbautsSkills__container":"AbautsSkills_AbautsSkills__container__M6c0w"};